import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3ijxsv0nzqion">
      <MetaPixel data-id="element-1" data-mp="3ml1397n9rmih" />
      <main data-id="element-2" data-mp="3mkhn9wh6j873">
        <Hero data-id="element-3" data-mp="3mk83wrqn3zad" />
        <SocialProofBar data-id="element-4" data-mp="3mjq3rk0ux0x6" />
        <PainGrid data-id="element-5" data-mp="3rc9e8848zfxr" />
        <ProductReveal data-id="element-6" data-mp="3rbrayrj641gc" />
        <Tomes data-id="element-7" data-mp="3rdki07xp0nov" />
        <Bonuses data-id="element-8" data-mp="3rcsulke91w9o" />
        <ValueStack data-id="element-9" data-mp="3recbnd7qcbci" />
        <Urgency data-id="element-10" data-mp="5ot150vj28n" />
        <Pricing data-id="element-11" data-mp="67znpl2q47d" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-12" data-mp="4n4pyuukj8z" />
        <Guarantee data-id="element-13" data-mp="2zlli5ahfl0qy" />
        <Faq data-id="element-14" data-mp="2zmepodo7rua5" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, more seasons" background="cream" data-id="element-15" data-mp="2zmo5j8fjol24" />
        <CostOfInaction data-id="element-16" data-mp="38m1e7yvuh5ls" />
        <Close data-id="element-17" data-mp="38kqc03i1s5ws" />
      </main>
      <Footer data-id="element-18" data-mp="38kgkgbhctqoz" />
      <PurchaseNotifications data-id="element-19" data-mp="38num1hi71vvd" />
    </div>;
}